export const SERVICES = [
  {
    slug: "estrategia-seo",
    num: "01",
    tag: "Diagnóstico • Priorização • Plano",
    name: "Estratégia SEO",
    card: "Diagnóstico, pesquisa e priorização para definir onde competir e por quê.",
    h1: "Estratégia SEO para crescer com direção.",
    lead: "Uma estratégia de SEO organiza oportunidades, limitações e prioridades antes de transformar tudo em tarefas. O ponto de partida é entender o negócio, o mercado e a forma como a demanda se manifesta nas buscas.",
    problemLead:
      "Sem direção, a operação tende a produzir conteúdo disperso, corrigir problemas de baixo impacto e acompanhar métricas que não explicam crescimento. A estratégia reduz esse ruído e cria uma sequência executável.",
    problemRest:
      "O diagnóstico separa sintomas, causas, dependências e oportunidades para evitar esforço em ações que não alteram o cenário.",
    image: "https://images.unsplash.com/photo-1622295023368-8d348ed7140e?q=80&w=1200&auto=format&fit=crop",
  },
  {
    slug: "seo-tecnico",
    num: "02",
    tag: "Rastreamento • Indexação • Performance",
    name: "SEO Técnico",
    card: "Rastreamento, indexação, arquitetura, performance e integridade técnica.",
    h1: "Base técnica para o Google entender e o usuário avançar.",
    lead: "SEO técnico reduz barreiras que impedem mecanismos de busca de acessar, interpretar e priorizar páginas — e que também prejudicam a experiência de quem navega.",
    problemLead:
      "Um site pode ter bom conteúdo e ainda perder visibilidade por arquitetura confusa, indexação inadequada, lentidão, duplicidade, redirecionamentos incorretos ou sinais técnicos contraditórios.",
    problemRest:
      "O diagnóstico separa sintomas, causas, dependências e oportunidades para evitar esforço em ações que não alteram o cenário.",
    image: "https://images.unsplash.com/photo-1542831371-29b0f74f9713?q=80&w=1200&auto=format&fit=crop",
  },
  {
    slug: "seo-on-page",
    num: "03",
    tag: "Intenção • Semântica • Conversão",
    name: "SEO On-Page",
    card: "Conteúdo, estrutura semântica, intenção de busca e otimização de páginas.",
    h1: "Páginas alinhadas à busca e ao negócio.",
    lead: "SEO on-page transforma uma página em uma resposta mais clara para a busca e em uma etapa mais útil para a jornada comercial. Não se resume a inserir termos em títulos.",
    problemLead:
      "Páginas genéricas, sobrepostas ou mal estruturadas dificultam a compreensão do tema, reduzem a utilidade do conteúdo e dispersam sinais entre URLs que competem entre si.",
    problemRest:
      "O diagnóstico separa sintomas, causas, dependências e oportunidades para evitar esforço em ações que não alteram o cenário.",
    image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?q=80&w=1200&auto=format&fit=crop",
  },
  {
    slug: "seo-local",
    num: "04",
    tag: "Presença • Proximidade • Confiança",
    name: "SEO Local",
    card: "Presença regional, consistência de dados e descoberta em buscas próximas.",
    h1: "Presença local para ser encontrado onde a decisão acontece.",
    lead: "SEO local organiza os sinais que ajudam uma empresa a ser descoberta por pessoas que procuram uma solução em determinada região, cidade ou área de atendimento.",
    problemLead:
      "Informações inconsistentes, perfil incompleto, páginas locais fracas e reputação mal acompanhada reduzem confiança e dificultam a descoberta em buscas de proximidade.",
    problemRest:
      "O diagnóstico separa sintomas, causas, dependências e oportunidades para evitar esforço em ações que não alteram o cenário.",
    image: "https://images.unsplash.com/photo-1758578484467-52d57a339904?q=80&w=1200&auto=format&fit=crop",
  },
  {
    slug: "autoridade-digital",
    num: "05",
    tag: "Conteúdo • Reputação • Relevância",
    name: "Autoridade Digital",
    card: "Conteúdo, reputação e aquisição ética de relevância para fortalecer confiança.",
    h1: "Autoridade construída com relevância e consistência.",
    lead: "Autoridade digital é construída quando a marca demonstra especialidade, mantém consistência e conquista referências relevantes. Não é um atalho baseado em volume de links.",
    problemLead:
      "Conteúdo sem profundidade, reputação fragmentada e aquisição artificial de links podem gerar pouco valor, risco e uma imagem de autoridade que não se sustenta.",
    problemRest:
      "O diagnóstico separa sintomas, causas, dependências e oportunidades para evitar esforço em ações que não alteram o cenário.",
    image: "https://images.unsplash.com/photo-1533750349088-cd871a92f312?q=80&w=1200&auto=format&fit=crop",
  },
  {
    slug: "analytics-performance",
    num: "06",
    tag: "Mensuração • Contexto • Evolução",
    name: "Analytics e Performance",
    card: "Monitoramento, relatórios e ciclos de melhoria conectados a indicadores.",
    h1: "Dados que orientam a próxima decisão.",
    lead: "Analytics e performance organizam sinais para responder o que evoluiu, onde existe perda e qual hipótese merece ser testada em seguida.",
    problemLead:
      "Relatórios extensos podem informar sem orientar. Quando posição, tráfego, conversão e execução não são analisados em conjunto, a equipe reage a variações sem compreender contexto.",
    problemRest:
      "O diagnóstico separa sintomas, causas, dependências e oportunidades para evitar esforço em ações que não alteram o cenário.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1200&auto=format&fit=crop",
  },
];

export const FULL_CATALOG = [
  {
    id: "desenvolvimento",
    num: "01",
    title: "Desenvolvimento",
    tagline: "Presença digital construída para crescer.",
    image: "https://images.unsplash.com/photo-1629904853893-c2c8981a1dc5?q=80&w=1200&auto=format&fit=crop",
    items: [
      { title: "Criação de Sites", desc: "Sites profissionais, institucionais e WordPress com estratégia, performance e estrutura preparada para aquisição.", href: "/criacao-de-sites" },
      { title: "Landing Pages", desc: "Páginas de conversão com mensagem, experiência e mensuração conectadas a uma ação de negócio." },
      { title: "Lojas Virtuais / E-commerce", desc: "E-commerce com arquitetura comercial, experiência, performance e base técnica preparada para aquisição e crescimento." },
    ],
  },
  {
    id: "marketing",
    num: "02",
    title: "Marketing & Performance",
    tagline: "Aquisição e dados com direção.",
    image: "https://images.unsplash.com/photo-1521737711867-e3b97375f902?q=80&w=1200&auto=format&fit=crop",
    items: [
      { title: "Gestão de Tráfego Pago", desc: "Campanhas pagas com estratégia, rastreamento e otimização para transformar investimento em demanda qualificada." },
      { title: "Marketing Digital", desc: "Estratégia digital que organiza canais, conteúdo, aquisição e mensuração em torno de objetivos claros de negócio." },
      { title: "Analytics e Performance", desc: "Monitoramento, relatórios e ciclos de melhoria conectados a indicadores." },
    ],
  },
  {
    id: "seo",
    num: "03",
    title: "SEO & Google",
    tagline: "Visibilidade com estrutura, relevância e intenção.",
    image: "https://images.unsplash.com/photo-1641951820920-c90394aef512?q=80&w=1200&auto=format&fit=crop",
    items: [
      { title: "Estratégia SEO", desc: "Diagnóstico, pesquisa e priorização para definir onde competir e por quê." },
      { title: "SEO Técnico", desc: "Rastreamento, indexação, arquitetura, performance e integridade técnica." },
      { title: "SEO On-Page", desc: "Conteúdo, estrutura semântica, intenção de busca e otimização de páginas." },
      { title: "SEO Local", desc: "Presença regional, consistência de dados e descoberta em buscas próximas." },
      { title: "Autoridade Digital", desc: "Conteúdo, reputação e aquisição ética de relevância para fortalecer confiança." },
    ],
  },
  {
    id: "automacao",
    num: "04",
    title: "Automação & IA",
    tagline: "Processos digitais com menos atrito.",
    image: "https://images.unsplash.com/photo-1771503735122-22405ba958f9?q=80&w=1200&auto=format&fit=crop",
    items: [
      { title: "Automação & IA", desc: "Automação, inteligência artificial e integrações para reduzir tarefas manuais, organizar dados e acelerar processos comerciais." },
    ],
  },
  {
    id: "suporte",
    num: "05",
    title: "Suporte & Infraestrutura",
    tagline: "Continuidade, velocidade e segurança.",
    image: "https://images.unsplash.com/photo-1691435828932-911a7801adfb?q=80&w=1200&auto=format&fit=crop",
    items: [
      { title: "Manutenção & Performance", desc: "Manutenção técnica, velocidade, segurança, backup e monitoramento para manter o site estável e pronto para performar." },
    ],
  },
];
